import { ProductDetailPage } from "./ProductDetailPage";

export function ProductionProductDetailPage() {
  return <ProductDetailPage catalogMode="production" />;
}
